exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--1EESE {\n  padding: 0 10px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #5d5d5d;\n}\n\n.client--16ho1 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 10px 5px;\n}\n\n.profile-icon--MFmIq {\n  fill: white;\n  stroke: white;\n  -webkit-transform: scale3d(1.1, 1.1, 1.1);\n          transform: scale3d(1.1, 1.1, 1.1);\n}\n\n.call-icon--373_Z {\n  margin-left: 10px;\n  fill: #8cc84d;\n  stroke: #8cc84d;\n  -webkit-transform: scale3d(1.1, 1.1, 1.1);\n          transform: scale3d(1.1, 1.1, 1.1);\n}\n\n.controls--1aq4w {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.controls--1aq4w > * {\n  margin-right: 5px;\n}\n\n.controls--1aq4w > *:last-of-type {\n  margin-right: 0;\n}\n\n.name--1KrdH {\n  color: white;\n  font-size: 16px;\n  line-height: 18px;\n  font-weight: 400;\n  padding: 0 10px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--1EESE",
	"client": "client--16ho1",
	"profile-icon": "profile-icon--MFmIq",
	"call-icon": "call-icon--373_Z",
	"controls": "controls--1aq4w",
	"name": "name--1KrdH"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/emission/client-summary/Client/Client.m.scss
// module id = 1452
// module chunks = 0